
export const signInRedirectBlacklist = new Set([
    '/forgot-password',
    '/reset-password',
    '/set-password',
    '/sign-out',
    '/create-account'
]);
